import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './DropdownMenu.scss';

import * as uiActions from '../../../store/actions/index';


class DropdownMenu extends Component {

    state = {
        toggle: false
    }

    componentWillMount() {
        document.addEventListener("mousedown", this.handleClick);
    }

    componentWillUnmount() {
        document.addEventListener("mousedown", this.handleClick);
    }

    handleClick = (e) => {
        if(this.node !== null && !this.node.contains(e.target)) {
            this.handleClickOutside();
        }
    }

    handleClickOutside = () => {
        this.setState({
            toggle: false
        })
    }

    toggleDropdownHandler = () => {
        // this.setState(prevState => {
        //     return { toggle: !prevState.toggle }
        // })
        this.setState({toggle: true})
    }

    render() {
        return (
            <React.Fragment>
                <div className={classes.Button} onClick={(e) => {
                    e.stopPropagation();
                    this.props.onOpenDropDown(this.props.index);
                    this.toggleDropdownHandler();
                }}>
                    <div className={classes.ButtonDotsContainer}>
                        <span className={classes.ButtonDots}></span>
                        <span className={classes.ButtonDots}></span>
                        <span className={classes.ButtonDots}></span>
                    </div>
                    <div className={classes.Dropdown} ref={node => this.node = node} style={{
                        opacity: this.props.index === this.props.dropDownIndex && this.state.toggle ? 1 : 0,
                        visibility: this.props.index === this.props.dropDownIndex && this.state.toggle ? 'visible': 'hidden',
                        transform: this.props.index === this.props.dropDownIndex && this.state.toggle ? 'scaleY(1)' : 'scaleY(0)',
                        transformOrigin: 'left top 0px'
                        }}>
                        {this.props.children}
                    </div>
                </div>                
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        isDropDownOpen: state.ui.isDropDownOpen,
        dropDownIndex: state.ui.dropDownIndex
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOpenDropDown: (id) => dispatch(uiActions.openDropDown(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DropdownMenu);


// WEBPACK FOOTER //
// ./src/components/UI/DropdownMenu/DropdownMenu.js